<template>
  <div class="">
    <Teleport to="body">
      <TransitionModal>
        <HomeModal v-if="homeModalOpen" @close="homeModalOpen = false" />
      </TransitionModal>
    </Teleport>
    <!-- <div class="relative">
      <img
        :src="
          parents ||
          'https://turbobabies.com/wp-content/uploads/2022/10/HERO-IMAGE-2-PARENT-RESOURCES-PAGE.jpg'
        "
        alt="Family on computer"
        class="object-cover object-center h-[400px] lg:h-auto lg:max-h-[450px] w-full"
      />
    </div>
    <img
      :src="funkyRoad"
      alt="Funky road"
      class="hidden lg:block lg:-mt-24 relative z-10 w-full"
    /> -->

    <section class="py-8 lg:pt-0 lg:pb-32 px-4 relative z-10 mt-8">
      <div class="max-w-screen-xl mx-auto lg:flex justify-center lg:mt-12">
        <div>
          <div class="relative lg:mb-8">
            <svg
              id="Group_9"
              data-name="Group 9"
              xmlns="http://www.w3.org/2000/svg"
              width="952.66"
              height="77.039"
              viewBox="0 0 952.66 77.039"
              class="mx-auto hidden lg:block text-brand-orange"
            >
              <path
                id="Path_5"
                data-name="Path 5"
                d="M175.37,77.028c-13.762-.182-30.337-.365-46.826-.641-14.2-.229-28.412-.641-42.689-.87-10.723-.182-21.522-.276-32.245-.411q-21.53-.273-43.061-.594a39.473,39.473,0,0,1-6.577-.641c-2.964-.552-4.517-2.333-3.7-3.979a19.53,19.53,0,0,1,2.736-4.167A278.658,278.658,0,0,1,28.457,40.84c.667-.6,1.326-1.146,1.993-1.693.372-.276.448-.505,0-.828Q20.027,29.468,10.7,20.069c-2.812-2.839-5.471-5.677-7.987-8.6A17.173,17.173,0,0,1,.2,7.533c-.743-1.51.667-3.156,3.251-3.844A21.428,21.428,0,0,1,7.67,3.049c4.8-.182,9.617-.276,14.421-.37,20.787-.271,41.651-.453,62.438-.776,13.02-.182,25.963-.594,38.907-.823C134.167.9,144.966.851,155.689.621c31-.547,61.914-.276,92.91-.047,17.832.094,35.731.505,53.555.828,8.139.135,16.279.453,24.418.594,5.767.089,11.61,0,17.385,0a48.764,48.764,0,0,1,9.026.87c1.849.365,2.583,1.281,2.735,2.333a41.678,41.678,0,0,1,.591,6.083c.076,5.078.076,10.156.076,15.234,0,10.109.144,20.177.068,30.286,0,4.76-.3,9.516-.515,14.276A4.681,4.681,0,0,1,355.423,73a3.484,3.484,0,0,1-2.744,1.557,55.445,55.445,0,0,1-10.723.729c-7.988,0-16.051.094-24.038.276-7.1.135-14.21.411-21.311.505-18.271.271-36.61.594-54.881.776-13.248.135-26.487.089-39.726.135C194,77.075,186.017,77.028,175.37,77.028Z"
                fill="currentColor"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M496.763.012c13.762.182,30.328.365,46.826.641,14.2.224,28.4.641,42.681.865,10.723.188,21.53.276,32.253.417q21.531.273,43.052.594a39.481,39.481,0,0,1,6.586.641c2.955.547,4.509,2.333,3.7,3.979a19.825,19.825,0,0,1-2.735,4.161A280.368,280.368,0,0,1,643.676,36.2c-.667.594-1.334,1.146-2,1.693-.363.276-.439.505,0,.823q10.436,8.852,19.757,18.255c2.812,2.839,5.471,5.672,7.987,8.6a17.351,17.351,0,0,1,2.516,3.932c.735,1.51-.667,3.156-3.259,3.844a21.823,21.823,0,0,1-4.213.641c-4.813.182-9.617.276-14.429.365-20.788.276-41.643.458-62.43.776-13.019.188-25.963.6-38.915.828-10.723.182-21.522.224-32.253.453-30.995.552-61.915.276-92.91.047-17.824-.088-35.723-.5-53.556-.823-8.139-.135-16.27-.458-24.409-.594-5.775-.094-11.618,0-17.385,0a49.153,49.153,0,0,1-9.026-.87c-1.849-.365-2.592-1.281-2.735-2.333a41.748,41.748,0,0,1-.591-6.083c-.076-5.078-.076-10.156-.076-15.24,0-10.109-.152-20.172-.076-30.287,0-4.755.3-9.516.523-14.271a4.681,4.681,0,0,1,.515-1.922,3.453,3.453,0,0,1,2.736-1.557,55.9,55.9,0,0,1,10.723-.734c8,0,16.059-.089,24.046-.271,7.1-.141,14.2-.411,21.3-.505C393.789.695,412.136.377,430.407.195,443.646.054,456.894.1,470.133.054,478.12-.034,486.108.012,496.763.012Z"
                fill="currentColor"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M777.3.012c13.754.182,30.328.365,46.818.641,14.21.224,28.411.641,42.689.865,10.723.188,21.522.276,32.253.417q21.517.273,43.052.594a39.4,39.4,0,0,1,6.578.641c2.963.547,4.517,2.333,3.706,3.979a19.53,19.53,0,0,1-2.744,4.161A279.077,279.077,0,0,1,924.212,36.2c-.667.594-1.334,1.146-2,1.693-.372.276-.448.505,0,.823q10.436,8.852,19.749,18.255c2.811,2.839,5.479,5.672,7.987,8.6a17.082,17.082,0,0,1,2.516,3.932c.743,1.51-.667,3.156-3.251,3.844a21.809,21.809,0,0,1-4.221.641c-4.805.182-9.617.276-14.421.365-20.788.276-41.651.458-62.438.776-13.02.188-25.963.6-38.907.828-10.723.182-21.53.224-32.253.453-30.995.552-61.915.276-92.91.047-17.832-.088-35.732-.5-53.556-.823-8.139-.135-16.278-.458-24.417-.594-5.767-.094-11.61,0-17.377,0a49.153,49.153,0,0,1-9.026-.87c-1.849-.365-2.592-1.281-2.744-2.333a41.884,41.884,0,0,1-.591-6.083c-.067-5.078-.067-10.156-.067-15.24,0-10.109-.152-20.172-.076-30.287,0-4.755.295-9.516.515-14.271a4.56,4.56,0,0,1,.523-1.922c.363-.828,1.4-1.328,2.736-1.557a55.847,55.847,0,0,1,10.723-.734c7.987,0,16.051-.089,24.046-.271,7.1-.141,14.2-.411,21.3-.505C674.325.695,692.672.377,710.943.195,724.182.054,737.421.1,750.66.054,758.656-.034,766.644.012,777.3.012Z"
                fill="currentColor"
              />
            </svg>
            <h2
              class="text-2xl md:text-4xl font-bold leading-normal text-center text-white lg:absolute top-1/2 lg:-translate-y-1/2 left-1/2 lg:-translate-x-1/2 z-10 lg:whitespace-nowrap bg-brand-orange px-4 py-2 lg:bg-transparent lg:p-0 rounded-lg"
            >
              {{ data.headline || 'Turbo Babies Community News' }}
            </h2>
          </div>
          <p
            v-if="data"
            class="mx-auto mt-3 max-w-[550px] text-xl text-gray-500 text-center sm:mt-4"
          >
            {{
              data.body ||
              `Explore new blog posts, find upcoming events near you, and share fun photos or video of you and your Turbo Baby!`
            }}
          </p>
          <div class="relative mx-auto max-w-7xl text-center">
            <div
              class="mx-auto mt-12 lg:grid max-w-lg gap-5 lg:!max-w-screen-xl lg:grid-cols-3"
            >
              <div class="col-span-1">
                <div class="text-left mb-8 bg-brand-orange p-6 rounded-lg">
                  <h2 class="text-lg font-bold text-white">
                    {{ data.events?.headline }}
                  </h2>
                  <div
                    v-html="data.events?.body"
                    class="text-white font-bold"
                  ></div>
                  <div class="mt-4 text-right">
                    <a
                      :href="data.events?.link?.url"
                      class="inline-block text-base bg-brand-purple px-4 py-2 text-center text-white hover:bg-brand-purple/75 rounded-full font-bold"
                      >{{ data.events?.link?.title }}</a
                    >
                  </div>
                </div>
                <div
                  v-if="
                    data.events?.events.filter((event) => {
                      const eventDate = new Date(event.date)
                      const today = new Date()

                      // Reset time component to compare dates only
                      today.setHours(0, 0, 0, 0)
                      eventDate.setHours(0, 0, 0, 0)

                      return eventDate >= today
                    }).length > 0
                  "
                  class="space-y-4 sticky top-[100px] mb-8 lg:mb-0"
                >
                  <div
                    v-for="event in data.events?.events.filter((event) => {
                      const eventDate = new Date(event.date)
                      const today = new Date()

                      // Reset time component to compare dates only
                      today.setHours(0, 0, 0, 0)
                      eventDate.setHours(0, 0, 0, 0)

                      return eventDate >= today
                    })"
                    class="bg-white rounded-xl p-4 flex items-center shadow-lg"
                  >
                    <div>
                      <div class="text-sm text-slate-500">
                        {{
                          new Date(event.date).toLocaleString('en-US', {
                            weekday: 'short',
                          })
                        }}
                      </div>
                      <div class="font-bold text-slate-900">
                        {{ new Date(event.date).getDate() }}
                      </div>
                      <div class="text-sm text-slate-500">
                        {{
                          new Date(event.date).toLocaleString('en-US', {
                            month: 'short',
                          })
                        }}
                      </div>
                    </div>

                    <div
                      class="flex items-center justify-between flex-grow text-left border-l ml-4 pl-4 border-slate-200"
                    >
                      <div>
                        <div class="text-brand-orange text-sm font-bold">
                          {{ event.location }}
                        </div>
                        <div class="font-bold">{{ event.title }}</div>
                        <div class="text-sm text-slate-500">
                          Starts at
                          {{
                            new Date(event.date).toLocaleString('en-US', {
                              hour: 'numeric',
                              minute: 'numeric',
                              hour12: true,
                            })
                          }}
                        </div>
                      </div>
                      <div>
                        <a
                          :href="event.link?.url"
                          class="block w-full bg-brand-purple px-2.5 py-1 text-center font-bold text-white font-bold rounded-full text-sm"
                        >
                          Details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="text-base text-gray-700 bg-gray-100 p-6 rounded-md"
                >
                  No events currently, check back soon!
                </div>
              </div>

              <div class="col-span-2 space-y-12 lg:space-y-4 rounded-xl">
                <a
                  :href="post.permalink"
                  v-for="post in data.posts"
                  :key="post.title"
                  class="lg:grid grid-cols-12 overflow-hidden rounded-lg text-left cursor-pointer shadow-lg block"
                >
                  <img
                    class="col-span-4 w-full lg:w-auto object-cover max-h-[240px] lg:max-h-auto lg:h-full rounded-t-lg lg:rounded-none"
                    :src="
                      post.thumbnail_url ||
                      'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80'
                    "
                    alt=""
                  />
                  <div
                    class="col-span-8 flex flex-1 flex-col justify-between bg-white p-6"
                  >
                    <div class="flex-1">
                      <!-- <p class="text-sm font-medium text-brand-dark-blue">
                    <a :href="post.category.href" class="hover:underline">{{
                      post.category.name
                    }}</a>
                  </p> -->
                      <div class="mt-2 block">
                        <p class="text-xl font-semibold text-gray-900">
                          {{ post.post_title }}
                        </p>
                        <p>
                          <span
                            v-for="category in post.categories"
                            class="text-xs text-purple-700 bg-purple-100 rounded-full px-2 py-0.5 border border-purple-300 mr-1"
                            >{{ category.name }}</span
                          >
                        </p>
                        <div
                          v-html="
                            post.post_excerpt
                              ? post.post_excerpt
                              : post.post_content.length > 100
                              ? post.post_content.substring(0, 200) + '...'
                              : post.post_content
                          "
                          class="mt-3 text-base text-gray-500"
                        ></div>
                      </div>
                    </div>
                    <!-- div class="mt-6 flex items-center">
                  <div class="">
                    <p class="text-sm text-gray-500">
                      <a :href="post.author.href" class="hover:underline">{{
                        post.author.name
                      }}</a>
                    </p>
                  </div>
                </div> -->
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue'
import critter1 from '../assets/critter1.svg'
import road from '../assets/road.svg'
import funkyRoad from '../assets/funkyRoad.png'
import HomeModal from '@/components/HomeModal.vue'
import TransitionModal from '@/components/transitions/TransitionModal.vue'

const homeModalOpen = ref(false)

let { data } = defineProps(['data'])

const checkScroll = () => {
  const scrollTop = window.scrollY
  const docHeight = document.documentElement.scrollHeight
  const winHeight = window.innerHeight
  const scrollPercent = (scrollTop / (docHeight - winHeight)) * 100

  if (scrollPercent >= 20) {
    homeModalOpen.value = true
    window.removeEventListener('scroll', checkScroll) // Remove the event listener after the condition is met
  }
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll)
})

const posts = [
  {
    title: 'Event #1',
    href: 'https://test-turbo-babies.pantheonsite.io/community-news/test-community-post/',
    category: { name: 'In-Person Meet-Up', href: '#' },
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto accusantium praesentium eius, ut atque fuga culpa, similique sequi cum eos quis dolorum.',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    imageUrl:
      'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '6 min',
    author: {
      name: '1613 N Franklin St. Tampa FL 33603',
      href: '#',
    },
  },
  {
    title: 'Event #2',
    href: 'https://test-turbo-babies.pantheonsite.io/community-news/test-community-post/',
    category: { name: 'Webinar', href: '#' },
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit facilis asperiores porro quaerat doloribus, eveniet dolore. Adipisci tempora aut inventore optio animi., tempore temporibus quo laudantium.',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    imageUrl:
      'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '4 min',
    author: {
      name: '1613 N Franklin St. Tampa FL 33603',
      href: '#',
    },
  },
  {
    title: 'Event #3',
    href: 'https://test-turbo-babies.pantheonsite.io/community-news/test-community-post/',
    category: { name: 'Webinar', href: '#' },
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint harum rerum voluptatem quo recusandae magni placeat saepe molestiae, sed excepturi cumque corporis perferendis hic.',
    date: 'Feb 12, 2020',
    datetime: '2020-02-12',
    imageUrl:
      'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    readingTime: '11 min',
    author: {
      name: '1613 N Franklin St. Tampa FL 33603',
      href: '#',
    },
  },
]
</script>
